import { SHOP } from 'config/api-routes';
import { DELETE, GET, PATCH, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export const MAX_REVIEW_LENGTH = 150;

export default class ShopFeedbackService {
  async getShopFeedbacks(shopId: number, queryParams?: Record<string, any>, opts = {}) {
    const response = await GET(SHOP.FEEDBACKS.LIST.GET(shopId, queryParams), opts);

    return formatResponse(response);
  }

  async addShopFeedback(shopId: number, data, opts = {}) {
    const response = await POST(SHOP.FEEDBACKS.POST(shopId), data, opts);

    return formatResponse(response);
  }

  async updateShopFeedback(feedbackId: number, data, opts = {}) {
    const response = await PATCH(SHOP.FEEDBACKS.PATCH(feedbackId), data, opts);

    return formatResponse(response);
  }

  async deleteShopFeedback(feedbackId: number, opts = {}) {
    const response = await DELETE(SHOP.FEEDBACKS.DELETE(feedbackId), opts);

    return formatResponse(response);
  }

  async addShopFeedbackReply(feedbackId: number, opts = {}) {
    const response = await POST(SHOP.FEEDBACKS.REPLY.POST(feedbackId), opts);

    return formatResponse(response);
  }

  async deleteShopFeedbackReply(feedbackId: number, opts = {}) {
    const response = await DELETE(SHOP.FEEDBACKS.REPLY.DELETE(feedbackId), opts);

    return formatResponse(response);
  }
}
